import { render } from "./SortComponent.vue?vue&type=template&id=2a26e7ec&scoped=true"
import script from "./SortComponent.vue?vue&type=script&lang=js"
export * from "./SortComponent.vue?vue&type=script&lang=js"

import "./SortComponent.vue?vue&type=style&index=0&id=2a26e7ec&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a26e7ec"]])

export default __exports__